export enum NavigationUnit {
	day = 'day',
	week = 'week',
	month = 'month',
}

export enum NavigationDirection {
	previous = -1,
	next = 1,
}
